import { useState } from "react";
import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import { Fragment } from "react";

export default function CheckBoxWithField({
  id,
  onChangeEvent,
  isPresent,
  edit,
  ...props
}) {
  const [Value, setValue] = useState(isPresent ?? false);
  const handleChange = () => {
    setValue(Boolean(!Value));
  };

  return (
    <Fragment key={props.id}>
      <Grid item sm={4} xs={10} p={1.5}>
        <TextField
          label="نمره دانش آموز"
          type="number"
          variant="outlined"
          fullWidth
          size="small"
          InputProps={{
            inputProps: { min: 0, max: 20, step: "0.25" },
          }}
          id="students"
          {...props.registerField}
          {...props.fieldProps}
          disabled={Value}
        />
      </Grid>
      <Grid item sm={2} xs={12} p={1.5}>
        <FormControlLabel
          control={
            <Checkbox
              id="is_present"
              {...props.register}
              checked={Value}
              onChange={handleChange}
            />
          }
          label="غیبت"
        />
      </Grid>
    </Fragment>
  );
}
